/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import useGame from './stores/useGame.js'

export default function Kirjat({ current, ...props }) {
  const { nodes, materials } = useGLTF('/Kirjat.glb')

  return <>
      {(current === 'table' || current === 'home') && (
      <>
        <directionalLight position={[1, 2, 3]} intensity={1.5} />
        <ambientLight intensity={0.3} />
      </>
    )}

    <group {...props} dispose={null} visible={current === 'table' || current === 'home'}>
<group name="tuli&savu" position={[-1.21, -9.53, 5.42]} rotation={[-Math.PI / 2, 0, 2.1]}>
        <mesh
          name="tuli&savu-TS"
          geometry={nodes['tuli&savu-TS'].geometry}
          material={materials.TS}
        />
        <mesh
          name="tuli&savu-TS_1"
          geometry={nodes['tuli&savu-TS_1'].geometry}
          material={materials.TS}
        />
        <mesh
          name="tuli&savu-sivut"
          geometry={nodes['tuli&savu-sivut'].geometry}
          material={materials.sivut}
        />
      </group>
      <group name="henkilökuvia" position={[-4.15, -9.67, 5.03]} rotation={[-Math.PI / 2, 0, 1.73]}>
        <mesh
          name="henkilökuvia-henkilokuvia"
          geometry={nodes['henkilökuvia-henkilokuvia'].geometry}
          material={materials.henkilokuvia}
        />
        <mesh
          name="henkilökuvia-henkilokuvia_1"
          geometry={nodes['henkilökuvia-henkilokuvia_1'].geometry}
          material={materials.henkilokuvia}
        />
        <mesh
          name="henkilökuvia-sivut"
          geometry={nodes['henkilökuvia-sivut'].geometry}
          material={materials.sivut}
        />
      </group>
      <mesh
        name="manifesto"
        geometry={nodes.manifesto.geometry}
        material={materials.manifesto}
        position={[-2.44, -9.43, 6.21]}
        rotation={[0, 0.03, 0.12]}
      />
      <group name="koru" position={[-3.03, -9.83, 7.12]}>
        <mesh name="koru-Mat" geometry={nodes['koru-Mat'].geometry} material={materials.Mat} />
        <mesh
          name="koru-Mat1"
          geometry={nodes['koru-Mat1'].geometry}
          material={materials['Mat.1']}
        />
        <mesh
          name="koru-Mat2"
          geometry={nodes['koru-Mat2'].geometry}
          material={materials['Mat.2']}
        />
      </group>
    </group>
  </>
}

useGLTF.preload('/Kirjat.glb')
